<script>
    import '$styles/app.css';

    import { navigating } from '$app/stores';

    import LoadingBar from '$lib/components/LoadingBar.svelte';
    import BackToTop from '$lib/components/BackToTop.svelte';
    import Notifs from '$lib/components/Notifs.svelte';
    import SEO from '$lib/components/SEO/SEO.svelte';
</script>

{#if $navigating}
	<LoadingBar />
{/if}

<Notifs />
<slot />
<BackToTop />
<SEO />